document.addEventListener("DOMContentLoaded", function() {
  const picker = document.querySelector("variant-picker[data-size-picker-config]");
  if (!picker) return;

  const config = JSON.parse(picker.getAttribute("data-size-picker-config") || "{}");
  const currentSize = picker.getAttribute("data-current-size");
  const sizePropertyInput = document.getElementById(`custom-size-property-${config.formId}`);
  const buttonText = config.popoverId ? document.getElementById(`${config.popoverId}-selected-value`) : null;

  const labels = {
    current: picker.getAttribute("data-current-size-label") || "מידה נוכחית",
    decrease: picker.getAttribute("data-decrease-label") || "הקטנה ל",
    increase: picker.getAttribute("data-increase-label") || "הגדלה ל"
  };

  // Change handler - update hidden input + button text
  picker.querySelectorAll(config.sizeInputSelector).forEach(function(input) {
    input.addEventListener("change", function() {
      if (!this.checked) return;

      const size = this.getAttribute(config.dataAttribute);
      if (!size) return;

      if (sizePropertyInput) sizePropertyInput.value = size;

      if (buttonText && currentSize) {
        const sizeNum = parseFloat(size);
        const currentNum = parseFloat(currentSize);
        const diff = !isNaN(sizeNum) && !isNaN(currentNum)
          ? sizeNum - currentNum
          : size.toLowerCase().localeCompare(currentSize.toLowerCase());

        if (diff === 0) {
          buttonText.textContent = `${labels.current}: ${size}`;
        } else if (diff < 0) {
          buttonText.textContent = `${labels.decrease} ${size}`;
        } else {
          buttonText.textContent = `${labels.increase} ${size}`;
        }
      }
    });
  });

  // Validation before cart add
  document.querySelectorAll(".buy-buttons").forEach(function(buyButtons) {
    buyButtons.addEventListener("click", function(e) {
      const button = e.target.closest("button");
      if (!button) return;

      const formId = buyButtons.getAttribute("form");
      if (!formId || !String(formId).startsWith(config.formId)) return;

      const checkedInput = picker.querySelector(`${config.sizeInputSelector}:checked`);
      if (checkedInput) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const form = document.getElementById(formId);
      if (form) {
        form.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: { error: "בחירת מידה" }
        }));
      }
    }, true);
  });
});
